import { render } from "./SuccessRegisterView.vue?vue&type=template&id=ecc98c2e&ts=true"
import script from "./SuccessRegisterView.vue?vue&type=script&lang=ts"
export * from "./SuccessRegisterView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__